import { agencyConfigs } from '../../configs';
import { getDevAgencyDomain, isDevMode } from '@/utils/devAgency';
const AGENCY_SLUG_PATTERN = /^[a-z0-9-]+$/;
let runtimeConfig = null;
function normalizeAgencySlug(value) {
    if (typeof value !== 'string') {
        return undefined;
    }
    const normalized = value.trim().toLowerCase();
    if (!normalized || !AGENCY_SLUG_PATTERN.test(normalized)) {
        return undefined;
    }
    return normalized;
}
function resolveAgencySlugFromHost() {
    if (typeof window === 'undefined') {
        return undefined;
    }
    const host = window.location.hostname.toLowerCase().trim();
    if (!host || host === 'localhost') {
        return undefined;
    }
    const subdomain = host.split('.')[0];
    if (!subdomain || subdomain === 'www' || subdomain === 'localhost') {
        return undefined;
    }
    return normalizeAgencySlug(subdomain);
}
function resolveAgencySlugFromEnvironment() {
    try {
        // @ts-ignore - DefinePlugin substitutes concrete env variable values at build time.
        return normalizeAgencySlug(process.env.B2C_AGENCY_SLUG);
    }
    catch {
        return undefined;
    }
}
function resolveAgencySlugFromDevDomain() {
    const devDomain = getDevAgencyDomain();
    if (!devDomain) {
        return undefined;
    }
    const matchedConfig = agencyConfigs.find((config) => config.agencyDomain === devDomain);
    return normalizeAgencySlug(matchedConfig?.agencyAlias);
}
export function setRuntimeConfig(config) {
    runtimeConfig = config;
}
export function getRuntimeConfig() {
    return runtimeConfig;
}
export function resolveCurrentAgencySlug() {
    const fromRuntimeConfig = normalizeAgencySlug(runtimeConfig?.agencyAlias);
    if (fromRuntimeConfig) {
        return fromRuntimeConfig;
    }
    if (isDevMode) {
        const fromDevDomain = resolveAgencySlugFromDevDomain();
        if (fromDevDomain) {
            return fromDevDomain;
        }
    }
    const fromEnvironment = resolveAgencySlugFromEnvironment();
    if (fromEnvironment) {
        return fromEnvironment;
    }
    return resolveAgencySlugFromHost();
}
